(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/betslip/betslip-wrapper.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/betslip/betslip-wrapper.js');
"use strict";



const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  withRouter
} = ReactRouterDOM;
const {
  Betslip,
  BetslipSticky
} = svs.components.lbUi.betslip;
const {
  BetslipPayOptionsContainer,
  actions,
  BetslipStickyContentContainer
} = svs.challenge;
const {
  format
} = svs.utils;
const {
  config
} = svs.core;
const {
  isSelfService
} = config.data.svsconfig;
const {
  AccountSelectorContainer,
  CommissionSelector,
  useAccount,
  payGame
} = svs.components.marketplace.accountSelector;
function makeUnpayableMessage(price) {
  if (price > svs.challenge.constants.MAX_COUPON_PRICE) {
    return "Systemet \xF6verskrider ".concat(format.Currency(svs.challenge.constants.MAX_COUPON_PRICE), " rader.");
  }
}
const BetslipWrapper = withRouter(_ref => {
  let {
    match,
    getScrollContainer
  } = _ref;
  const dispatch = useDispatch();
  function onInitiatePayment() {
    dispatch(actions.initiatePayment());
  }
  const drawNumber = Number(match.params.drawNumber);
  const {
    marketplaceAccount,
    accountBalance,
    hasMarketplaceAccount
  } = useAccount(drawNumber, svs.utils.products.productIds.CHALLENGE);
  const {
    isPayable,
    betslipPrice
  } = useSelector(state => {
    const coupon = svs.challenge.helpers.getCouponByDrawNumber(state, drawNumber);
    return {
      isPayable: coupon.isPayable,
      betslipPrice: coupon.betSum
    };
  });
  const onPayClickHandler = () => payGame({
    marketplaceAccount,
    drawNumber,
    productId: svs.utils.products.productIds.CHALLENGE
  }, onInitiatePayment);
  return React.createElement(Betslip, {
    accountBalance: accountBalance,
    errorMessage: makeUnpayableMessage(betslipPrice),
    getScrollContainer: getScrollContainer,
    isPayable: isPayable,
    isSelfService: isSelfService,
    onPay: onPayClickHandler,
    price: betslipPrice
  }, React.createElement("div", {
    className: "betslip-tag"
  }), React.createElement(BetslipSticky, null, hasMarketplaceAccount && marketplaceAccount && React.createElement("div", {
    className: "chlng-betslip-tag"
  }, marketplaceAccount.name || 'okänt'), React.createElement(BetslipStickyContentContainer, null)), React.createElement(BetslipPayOptionsContainer, null), hasMarketplaceAccount && React.createElement("div", {
    className: "account-selector-holder"
  }, svs.challenge.data.isRetailerAdmin && React.createElement(CommissionSelector, {
    className: "padding"
  }), React.createElement(AccountSelectorContainer, null)));
});
setGlobal('svs.challenge.BetslipWrapper', BetslipWrapper);

 })(window);